var React = require('react');

function IconCircleO (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"513","cy":"512.4","r":"445"}));
}

IconCircleO.displayName = "IconCircleO";

IconCircleO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCircleO;

IconCircleO.default = IconCircleO;
